import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal({ open, handleClose }: { open: boolean, handleClose: () => void }) {
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <CheckCircleIcon sx={{ color: 'green', fontSize: 50 }} />
          </Box>
          <Typography variant='h4' textAlign={'center'} component={'div'} sx={{ mt: 2 }}>
              شكرًا لاختيارك خدماتنا, سيتم التواصل معك لتنسيق موعد تسليم طلبك    
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}